module.exports = __webpack_public_path__ + "static/media/individualPanels.99264a0e.jpg";